import { insert as o, createComponent as a, mergeProps as i, effect as l, className as p, template as m } from "solid-js/web";
import { For as c } from "solid-js";
import { SelectorOptionButton as d } from "../SelectorOptionButton/index.js";
import { cn as n } from "../../utils/class.js";
var u = m("<div>");
function x(t) {
  return e = u(), o(e, a(c, { get each() {
    return t.array;
  }, children: (r, s) => a(d, i(t, { value: r, index: s, get className() {
    return n(`
              rn-p-2 
              rn-text-[0.9375rem]
            `, { "disabled:rn-bg-transparent": !r }, t.className);
  }, disabled: !r, get attributes() {
    return { ...r ? {} : { "data-selector-type": "selector-option-out-of-range" } };
  } })) })), l(() => p(e, n(`
        date-year-full-size-selector-options 
        rn-grid 
        rn-grid-cols-4
        rn-gap-x-1
      `))), e;
  var e;
}
export {
  x as default
};
